import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess(
  state: State,
  { nbr }: Boundaries["retrieveUnReadNotificationsNbr"]["success"],
): State {
  return { ...state, request: setRequestStateToSuccess(), nbr };
}

function handleFailure(state: State): State {
  return { ...state, request: setRequestStateToFailure() };
}

function handleMarkNotificationsAsReadRequest(
  state: State,
  notifications: Boundaries["markNotificationsAsRead"]["request"],
): State {
  return { ...state, nbr: state.nbr - notifications.length };
}

function handleMarkNotificationsAsReadSuccess(
  state: State,
  notifications: Boundaries["markNotificationsAsRead"]["success"],
): State {
  return {
    ...state,
    nbr: notifications.length === 0 ? 0 : state.nbr - notifications.length,
  };
}

function handleMarkNotificationsAsReadFailure(
  state: State,
  notifications: Boundaries["markNotificationsAsRead"]["failure"],
): State {
  return { ...state, nbr: state.nbr + notifications.length };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveUnReadNotificationsNbrRequested]: handleRequest,
    [events.retrieveUnReadNotificationsNbrSucceeded]: handleSuccess,
    [events.retrieveUnReadNotificationsNbrFailed]: handleFailure,
    [events.markNotificationsAsReadRequested]:
      handleMarkNotificationsAsReadRequest,
    [events.markNotificationsAsReadSucceeded]:
      handleMarkNotificationsAsReadSuccess,
    [events.markNotificationsAsReadFailed]:
      handleMarkNotificationsAsReadFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
